import React from 'react';
import { SsiHeader as Header } from 'smartsuite-ui';
import { useLabelContext } from '../../shared/hooks/labelContext';
import { useFeatureTokenContext } from '../../shared/hooks/featureTokensContext';

export default function SsiHeader() {
    const { ssiLabels } = useLabelContext();
    const { ssiSystemFeature } = useFeatureTokenContext();

    if (!ssiSystemFeature?.header) {
        return null;
    }

    return <Header ssiLabels={ssiLabels} />;
}
